import { render, staticRenderFns } from "./investPlaceItem.vue?vue&type=template&id=3a5ba770&"
import script from "./investPlaceItem.vue?vue&type=script&lang=js&"
export * from "./investPlaceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports